module.exports = " <div class=\"ztree category-ztree\" :id=ztreeId></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/multi-category/ztree.vue
// module id = 305
// module chunks = 0